import React from 'react';

export const GROUPING_LABELS = {
	DEFAULT_TITLE: 'Grouping rules',
	ADD_RULE: 'Add rule',
	MAX_PAGES_LABEL: 'Max pages to crawl'
} as const;

export const GROUPING_MORE_INFO = (
	<>
		Grouping rules serve two main purposes: <br />
		<ol>
			<li>
				Mapping URLs to unique pages. <br />
				For example, do differences in query parameters, case sensitivity etc. map to one page or
				different pages?
			</li>
			<li>
				Sample similar pages to reduce the time/size of the scan. <br />
				For example in e-commerce sites, with hundreds of thousands of pages, it may be enough to
				analyze a smaller sample.
			</li>
		</ol>
	</>
);
